import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

export default Schema.object({
  statusSolicitado: Schema.any()
    .label(<FormattedMessage id="labelStatusSolicitado" />)
    .required(),
  justificativa: Schema.string()
    .label(<FormattedMessage id="labelDescricaoJustificativa" />)
    .required(),
});
